import { render, staticRenderFns } from "./NewThemeTableItemSkeleton.vue?vue&type=template&id=3f1be59a&scoped=true"
import script from "./NewThemeTableItemSkeleton.vue?vue&type=script&lang=js"
export * from "./NewThemeTableItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./NewThemeTableItemSkeleton.vue?vue&type=style&index=0&id=3f1be59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1be59a",
  null
  
)

export default component.exports